module.exports = __webpack_public_path__ + "media/images/forms-icons/single-select-icon-e9a4147d3c09be34b517d40daefff583.svg";